import SearchForm from './SearchForm'
import Router from 'next/router'
import { truckFormInputs, truckAdvancedInputs,
    truckFormInputsMobile, truckAdvancedInputsMobile } from '@components/search/truckFormInputs'
import { TRUCK_LINK_BASE } from '@constants/searchFormLinks'
import paliwo from '@components/search/inputs/paliwo'

import searchFormLink from '@utils/links/searchFormLink'

const TruckForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: TRUCK_LINK_BASE,
            isMakeModelBase: true
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={truckFormInputs}
        mobileInputs={truckFormInputsMobile}
        dataKey="truck"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo,
            clear: true,
            advancedOptions: truckAdvancedInputs,
            advancedOptionsMobile: truckAdvancedInputsMobile,
        }} />
}

export default TruckForm